import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {IScheduleState} from '../../store/reducers/schedule.reducer';
import {NgRedux, Select} from '@angular-redux3/store';
import {getActiveDayIndex, TimeSlot} from '../../store/entities';
import {AEditSchedule, AFetchSchedule, PlaylistRemoteAppState} from '../../store';
import {SlotForm} from '../../store/entities/slotForm';

@Component({
  selector: 'mwo-edit-scheduler-page',
  templateUrl: './edit-scheduler-page.component.html',
  styleUrls: ['./edit-scheduler-page.component.scss']
})
export class EditSchedulerPageComponent implements OnInit, OnDestroy {

  activeDay$: Observable<string> = this.ngRedux.select('activeDay');
  schedule$: Observable<IScheduleState> = this.ngRedux.select('schedule');
  @Select(['schedule', 'scheduleUpdateLoading']) scheduleUpdateLoading$: Observable<boolean>;
  updateLoading: boolean;
  isCanceling: boolean = false;
  activeDay: string;
  slots: TimeSlot[] = [];
  private subscriptions: Subscription[] = [];

  constructor(private router: Router, private ngRedux: NgRedux<PlaylistRemoteAppState>) {
  }

  ngOnInit(): void {
    const activeDaySubscription = this.activeDay$.subscribe((day) => {
      this.activeDay = day;
    });
    this.subscriptions.push(activeDaySubscription);

    const scheduleSubscription = this.schedule$.subscribe((schedule) => {
      this.slots = (schedule[this.activeDay] || {}).slots || [];
    });
    this.subscriptions.push(scheduleSubscription);

    const scheduleUpdateLoadingSubscription = this.scheduleUpdateLoading$.subscribe(value => {
      this.updateLoading = value;
    });
    this.subscriptions.push(scheduleUpdateLoadingSubscription);

    this.slots.sort((a, b) => {
      const startTimeA = a.startTime[0] * 60 + a.startTime[1];
      const startTimeB = b.startTime[0] * 60 + b.startTime[1];
      return startTimeA - startTimeB;
    });

    this.mergeAdjacentSlots();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  handleEdit(index: number) {
    this.router.navigate(['/edit-slot-page'], {queryParams: {slotPosition: index}});
  }

  handleAdd() {
    this.router.navigate(['edit-slot-page']);
  }

  handleCancel() {
    this.isCanceling = true;
    this.ngRedux.dispatch(AFetchSchedule());
    setTimeout(() => {
      this.isCanceling = false;
      this.router.navigate(['scheduler-modifier']);
    }, 1300);
  }

  handleValidate() {
    const dayScheduleIndex = getActiveDayIndex(this.activeDay);
    const payload: SlotForm[] = this.slots.map(slot => {
      return {
        name: slot.event?.name,
        start: slot.startTime,
        end: slot.endTime,
        shuffled: slot.shuffle,
        playlist: slot.event,
        playrule: slot.tempo,
        dayOfTheWeek: dayScheduleIndex
      };
    });
    this.ngRedux.dispatch(AEditSchedule(payload));
    setTimeout(() => {
      this.ngRedux.dispatch(AFetchSchedule());
    }, 1500);
    setTimeout(() => {
      this.router.navigate(['/scheduler']);
    }, 300);
  }

  // handleDelete(index: number) {
  //     this.currentDeleteIndex = index;
  //     this.currentDeleteIndex = -1;
  // }

  canValidate(): boolean {
    const allSlotsHaveEventOrPlayrule = this.slots.every(slot => slot.event || slot.tempo);
    if (!allSlotsHaveEventOrPlayrule) {
      return false;
    }

    let totalCoveredTime = 0;
    for (const slot of this.slots) {
      const startTimeInMinutes = slot.startTime[0] * 60 + slot.startTime[1];
      const endTimeInMinutes = slot.endTime[0] * 60 + slot.endTime[1];
      totalCoveredTime += endTimeInMinutes - startTimeInMinutes;
    }

    return totalCoveredTime === 1439;
  }

  private mergeAdjacentSlots() {
    let i = 0;
    while (i < this.slots.length - 1) {
      const currentSlot = this.slots[i];
      const nextSlot = this.slots[i + 1];

      // Si les deux slots ont la même playlist et se terminent/commencent au même moment
      if (((currentSlot.event != undefined && nextSlot.event != undefined && currentSlot.event.id === nextSlot.event.id) || (currentSlot.tempo != undefined && nextSlot.tempo != undefined && currentSlot.tempo.id === nextSlot.tempo.id)) && this.timeAEquivalentToTimeB(currentSlot.endTime, nextSlot.startTime)) {
        // Fusionner les deux slots en un seul
        currentSlot.endTime = nextSlot.endTime;
        // Supprimer le slot suivant
        this.slots.splice(i + 1, 1);
      } else {
        // Passer au slot suivant
        i++;
      }
    }
  }

  private timeAEquivalentToTimeB(timeA: number[], timeB: number[]): boolean {
    return timeA[0] === timeB[0] && timeA[1] === timeB[1];
  }

}
